import palette from '../palette';

export default {
  styleOverrides: {
    root: {
      borderBottom: `2px solid ${palette.divider}`,
    },
  },
};
